import ResourceTypes from '../components/ResourceTypes';
const seedrandom = require('seedrandom');

const generateTerrain = (terrain, planet) => {
  console.log('Generating terrain on', terrain.position);
  let renderedTile = [],
    Xalign = terrain.position.x % 16,
    Yalign = terrain.position.y % 9;

  for (let y = 0; y < 9 - Yalign; y++) {
    renderedTile[y] = [];
    for (let x = 0; x < 16 - Xalign; x++) {
      renderedTile[y][x] =
        planet.terrains[Math.floor(terrain.position.y / 9)][
          Math.floor(terrain.position.x / 16)
        ].terrain[Yalign + y][Xalign + x];
    }
    for (let x = 16 - Xalign; x < 16; x++) {
      renderedTile[y][x] =
        planet.terrains[Math.floor(terrain.position.y / 9)][
          Math.floor(terrain.position.x / 16) + 1
        ].terrain[(terrain.position.y + y) % 9][Math.abs(16 - Xalign - x)];
    }
  }
  for (let y = 9 - Yalign; y < 9; y++) {
    renderedTile[y] = [];
    for (let x = 0; x < 16 - Xalign; x++) {
      renderedTile[y][x] = renderedTile[y][x] =
        planet.terrains[Math.floor(terrain.position.y / 9) + 1][
          Math.floor(terrain.position.x / 16)
        ].terrain[Math.abs(9 - Yalign - y)][(terrain.position.x + x) % 16];
    }
    for (let x = 16 - Xalign; x < 16; x++) {
      renderedTile[y][x] =
        renderedTile[y][x] =
        renderedTile[y][x] =
          planet.terrains[Math.floor(terrain.position.y / 9) + 1][
            Math.floor(terrain.position.x / 16) + 1
          ].terrain[(terrain.position.y + y) % 9][
            (terrain.position.x + x) % 16
          ];
    }
  }
  let terrainTile = renderedTile;

  let resourcesAmount = Math.floor(seedrandom(planet.seed)() * 10) + 10;
  let terrainArray = [],
    possiblePositions = [],
    resourceTypesWeighted = [],
    waterIntensity = 0;

  for (let i = 0; i < ResourceTypes.length; i++) {
    for (let j = 0; j < ResourceTypes[i].rarity; j++) {
      resourceTypesWeighted.push(ResourceTypes[i]);
    }
  }

  for (let i = 0; i < 9; i++) {
    terrainArray[i] = [];
    for (let j = 0; j < 16; j++) {
      terrainArray[i][j] = '00';
      if (terrainTile[i][j] > 0) {
        ++waterIntensity;
      }
      if (
        i !== 0 &&
        j !== 0 &&
        i !== 8 &&
        j !== 15 &&
        i * 16 + j !== 17 &&
        i * 16 + j !== 18 &&
        i * 16 + j !== 113 &&
        i * 16 + j !== 114
      ) {
        if (terrainTile[i][j] > 0) {
          possiblePositions.push([i, j]);
        }
      }
    }
  }

  resourcesAmount = Math.floor(waterIntensity / resourcesAmount);

  let resourcesArray = [];
  while (resourcesAmount > 0) {
    let randPos = Math.floor(
      seedrandom(
        planet.seed *
          ((terrain.position.x + 1) / (terrain.position.y + 1)) *
          resourcesAmount
      )() * possiblePositions.length
    );

    resourcesArray.push(possiblePositions[randPos]);
    possiblePositions.splice(randPos, 1);
    --resourcesAmount;
  }

  for (let i = 0; i < resourcesArray.length; i++) {
    if (typeof resourcesArray[i] !== 'undefined')
      terrainArray[resourcesArray[i][0]][resourcesArray[i][1]] = 'resource';
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let type = '',
        posX = x,
        posY = y;
      if (terrainTile[posY][posX] < 0) {
        if (terrainTile[posY][posX] < -0.6) {
          type = '222';
        } else if (terrainTile[posY][posX] < -0.3) {
          type = '65';
        } else {
          type = '62';
        }
      } else if (terrainTile[posY][posX] > 0.1) {
        if (terrainTile[posY][posX] > 1) {
          type = '112';
        } else if (terrainTile[posY][posX] > 0.6) {
          type = '138';
        } else if (terrainTile[posY][posX] > 0.3) {
          type = '03';
        } else {
          type = '01';
        }
      } else {
        type = '31';
      }
      if (terrainArray[y][x] === 'resource') {
        terrain.map[y * 16 + x] = JSON.parse(
          JSON.stringify(
            resourceTypesWeighted[
              Math.floor(
                seedrandom(planet.seed * y * x)() * resourceTypesWeighted.length
              )
            ]
          )
        );
        terrain.map[y * 16 + x].id = y * 16 + x;
        terrain.map[y * 16 + x].tile = type;
        terrain.map[y * 16 + x].y = y;
        terrain.map[y * 16 + x].x = x;
        terrain.map[y * 16 + x].type = 'resource';
        terrain.map[y * 16 + x].totalResources = Math.floor(
          seedrandom(Math.abs(terrainTile[posY][posX]))() * 10000 + 1000
        );
      } else {
        terrain.map[y * 16 + x] = {
          id: y * 16 + x,
          tile: type,
          height: terrainTile[posY][posX],
          y: y,
          x: x,
        };
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (block.current.tile === '62') {
        if (block.left !== undefined && x !== 0) {
          if (block.left.tile === '31') {
            block.left.tile = '31r';
          }
        }
        if (block.right !== undefined && x !== 15) {
          if (block.right.tile === '31') {
            block.right.tile = '31l';
          }
        }
      }
      if (block.current.tile === '31') {
        if (block.left !== undefined && x !== 0) {
          if (block.left.tile === '01') {
            block.left.tile = ['01r', 31];
          }
        }
        if (block.right !== undefined && x !== 15) {
          if (block.right.tile === '01') {
            block.right.tile = ['01l', 31];
          }
        }
      }
      if (block.current.tile === '01') {
        if (block.left !== undefined && x !== 0) {
          if (block.left.tile === '03') {
            block.left.tile = ['03r', '01'];
          }
        }
        if (block.right !== undefined && x !== 15) {
          if (block.right.tile === '03') {
            block.right.tile = ['03l', '01'];
          }
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };

      if (block.current.tile === '62') {
        if (block.bottom !== undefined) {
          if (block.bottom.tile === '31') {
            block.bottom.tile = '31t';
          }
        }
        if (block.top !== undefined) {
          if (block.top.tile === '31') {
            block.top.tile = '31b';
          }
        }
      }

      if (block.current.tile === '31') {
        if (block.bottom !== undefined) {
          if (block.bottom.tile === '01') {
            block.bottom.tile = ['01t', 31];
          }
        }
        if (block.top !== undefined) {
          if (block.top.tile === '01') {
            block.top.tile = ['01b', 31];
          }
        }
      }

      if (block.current.tile === '01') {
        if (block.bottom !== undefined) {
          if (block.bottom.tile === '03') {
            block.bottom.tile = ['03t', '01'];
          }
        }
        if (block.top !== undefined) {
          if (block.top.tile === '03') {
            block.top.tile = ['03b', '01'];
          }
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (block.current.tile === '31') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile === '31b' && block.bottom.tile === '31l') {
            block.current.tile = '31bli';
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (block.top.tile === '31r' && block.right.tile === '31t') {
            block.current.tile = '31tri';
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (block.left.tile === '31t' && block.top.tile === '31l') {
            block.current.tile = '31tli';
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile === '31b' && block.bottom.tile === '31r') {
            block.current.tile = '31bri';
          }
        }
      }

      if (block.current.tile === '01') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile[0] === '01b' && block.bottom.tile[0] === '01l') {
            block.current.tile = ['01bli', '01'];
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (block.top.tile[0] === '01r' && block.right.tile[0] === '01t') {
            block.current.tile = ['01tri', '01'];
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (block.left.tile[0] === '01t' && block.top.tile[0] === '01l') {
            block.current.tile = ['01tli', '01'];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile[0] === '01b' && block.bottom.tile[0] === '01r') {
            block.current.tile = ['01bri', '01'];
          }
        }
      }

      if (block.current.tile === '03') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile[0] === '03b' && block.bottom.tile[0] === '03l') {
            block.current.tile = ['03bli', '03'];
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (block.top.tile[0] === '03r' && block.right.tile[0] === '03t') {
            block.current.tile = ['03tri', '03'];
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (block.left.tile[0] === '03t' && block.top.tile[0] === '03l') {
            block.current.tile = ['03tli', '03'];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile[0] === '03b' && block.bottom.tile[0] === '03r') {
            block.current.tile = ['03bri', '03'];
          }
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (block.left !== undefined && block.right !== undefined) {
        if (
          block.current.tile === '31l' &&
          block.left.tile === '62' &&
          block.right.tile === '31t'
        ) {
          block.current.tile = '31tlc';
        }
        if (
          block.current.tile === '31l' &&
          block.left.tile === '62' &&
          block.right.tile === '31b'
        ) {
          block.current.tile = '31blc';
        }
        if (
          block.current.tile === '31r' &&
          block.left.tile === '31t' &&
          block.right.tile === '62'
        ) {
          block.current.tile = '31trc';
        }
        if (
          block.current.tile === '31r' &&
          block.left.tile === '31b' &&
          block.right.tile === '62'
        ) {
          block.current.tile = '31brc';
        }
      }
      if (block.left !== undefined && block.right !== undefined) {
        if (
          block.current.tile[0] === '01l' &&
          block.left.tile === '31' &&
          block.right.tile[0] === '01t'
        ) {
          block.current.tile = ['01tlc', '31'];
        }
        if (
          block.current.tile[0] === '01l' &&
          block.left.tile === '31' &&
          block.right.tile[0] === '01b'
        ) {
          block.current.tile = ['01blc', '31'];
        }
        if (
          block.current.tile[0] === '01r' &&
          block.left.tile[0] === '01t' &&
          block.right.tile === '31'
        ) {
          block.current.tile = ['01trc', '31'];
        }
        if (
          block.current.tile[0] === '01r' &&
          block.left.tile[0] === '01b' &&
          block.right.tile === '31'
        ) {
          block.current.tile = ['01brc', '31'];
        }
      }
      if (block.left !== undefined && block.right !== undefined) {
        if (
          block.current.tile[0] === '03l' &&
          block.left.tile === '01' &&
          block.right.tile[0] === '03t'
        ) {
          block.current.tile = ['03tlc', '01'];
        }
        if (
          block.current.tile[0] === '03l' &&
          block.left.tile === '01' &&
          block.right.tile[0] === '03b'
        ) {
          block.current.tile = ['03blc', '01'];
        }
        if (
          block.current.tile[0] === '03r' &&
          block.left.tile[0] === '03t' &&
          block.right.tile === '01'
        ) {
          block.current.tile = ['03trc', '01'];
        }
        if (
          block.current.tile[0] === '03r' &&
          block.left.tile[0] === '03b' &&
          block.right.tile === '01'
        ) {
          block.current.tile = ['03brc', '01'];
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (block.current.tile === '31') {
        if (block.top !== undefined && block.right !== undefined) {
          if (block.top.tile === '31r' && block.right.tile === '31r') {
            block.current.tile = '31tri';
            block.right.tile = '31trc';
          }
        }
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile === '31l' && block.bottom.tile === '31l') {
            block.current.tile = '31bli';
            block.left.tile = '31blc';
          }
        }
        if (block.top !== undefined && block.left !== undefined) {
          if (block.top.tile === '31l' && block.left.tile === '31l') {
            block.current.tile = '31tli';
            block.left.tile = '31tlc';
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile === '31r' && block.bottom.tile === '31r') {
            block.current.tile = '31bri';
            block.right.tile = '31brc';
          }
        }
      }
      if (block.current.tile === '01') {
        if (block.top !== undefined && block.right !== undefined) {
          if (block.top.tile[0] === '01r' && block.right.tile[0] === '01r') {
            block.current.tile = ['01tri', 31];
            block.right.tile = ['01trc', 31];
          }
        }
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile[0] === '01l' && block.bottom.tile[0] === '01l') {
            block.current.tile = ['01bli', 31];
            block.left.tile = ['01blc', 31];
          }
        }
        if (block.top !== undefined && block.left !== undefined) {
          if (block.top.tile[0] === '01l' && block.left.tile[0] === '01l') {
            block.current.tile = ['01tli', 31];
            block.left.tile = ['01tlc', 31];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile[0] === '01r' && block.bottom.tile[0] === '01r') {
            block.current.tile = ['01bri', 31];
            block.right.tile = ['01brc', 31];
          }
        }
      }
      if (block.current.tile === '03') {
        if (block.top !== undefined && block.right !== undefined) {
          if (block.top.tile[0] === '03r' && block.right.tile[0] === '03r') {
            block.current.tile = ['03tri', '01'];
            block.right.tile = ['03trc', '01'];
          }
        }
        if (block.left !== undefined && block.bottom !== undefined) {
          if (block.left.tile[0] === '03l' && block.bottom.tile[0] === '03l') {
            block.current.tile = ['03bli', '01'];
            block.left.tile = ['03blc', '01'];
          }
        }
        if (block.top !== undefined && block.left !== undefined) {
          if (block.top.tile[0] === '03l' && block.left.tile[0] === '03l') {
            block.current.tile = ['03tli', '01'];
            block.left.tile = ['03tlc', '01'];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (block.right.tile[0] === '03r' && block.bottom.tile[0] === '03r') {
            block.current.tile = ['03bri', '01'];
            block.right.tile = ['03brc', '01'];
          }
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (block.current.tile === '31') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (
            block.left.tile === '31l' &&
            block.current.tile === '31' &&
            block.bottom.tile === '31blc'
          ) {
            block.left.tile = '31blc';
            block.current.tile = '31bli';
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (
            block.right.tile === '31r' &&
            block.current.tile === '31' &&
            block.bottom.tile === '31brc'
          ) {
            block.right.tile = '31brc';
            block.current.tile = '31bri';
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (
            block.left.tile === '31l' &&
            block.current.tile === '31' &&
            block.top.tile === '31tlc'
          ) {
            block.left.tile = '31tlc';
            block.current.tile = '31tli';
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (
            block.right.tile === '31r' &&
            block.current.tile === '31' &&
            block.top.tile === '31trc'
          ) {
            block.right.tile = '31trc';
            block.current.tile = '31tri';
          }
        }
      }
      if (block.current.tile === '01') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (
            block.left.tile[0] === '01l' &&
            block.current.tile === '01' &&
            block.bottom.tile[0] === '01blc'
          ) {
            block.left.tile = ['01blc', 31];
            block.current.tile = ['01bli', 31];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (
            block.right.tile[0] === '01r' &&
            block.current.tile === '01' &&
            block.bottom.tile[0] === '01brc'
          ) {
            block.right.tile = ['01brc', 31];
            block.current.tile = ['01bri', 31];
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (
            block.left.tile[0] === '01l' &&
            block.current.tile === '01' &&
            block.top.tile[0] === '01tlc'
          ) {
            block.left.tile = ['01tlc', 31];
            block.current.tile = ['01tli', 31];
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (
            block.right.tile[0] === '01r' &&
            block.current.tile === '01' &&
            block.top.tile[0] === '01trc'
          ) {
            block.right.tile = ['01trc', 31];
            block.current.tile = ['01tri', 31];
          }
        }
      }

      if (block.current.tile === '03') {
        if (block.left !== undefined && block.bottom !== undefined) {
          if (
            block.left.tile[0] === '03l' &&
            block.current.tile === '03' &&
            block.bottom.tile[0] === '03blc'
          ) {
            block.left.tile = ['03blc', '01'];
            block.current.tile = ['03bli', '01'];
          }
        }
        if (block.right !== undefined && block.bottom !== undefined) {
          if (
            block.right.tile[0] === '03r' &&
            block.current.tile === '03' &&
            block.bottom.tile[0] === '03brc'
          ) {
            block.right.tile = ['03brc', '01'];
            block.current.tile = ['03bri', '01'];
          }
        }
        if (block.left !== undefined && block.top !== undefined) {
          if (
            block.left.tile[0] === '03l' &&
            block.current.tile === '03' &&
            block.top.tile[0] === '03tlc'
          ) {
            block.left.tile = ['03tlc', '01'];
            block.current.tile = ['03tli', '01'];
          }
        }
        if (block.right !== undefined && block.top !== undefined) {
          if (
            block.right.tile[0] === '03r' &&
            block.current.tile === '03' &&
            block.top.tile[0] === '03trc'
          ) {
            block.right.tile = ['03trc', '01'];
            block.current.tile = ['03tri', '01'];
          }
        }
      }
    }
  }

  for (let y = 0; y < 9; y++) {
    for (let x = 0; x < 16; x++) {
      let { map } = terrain;
      let block = {
        current: map[y * 16 + x],
        left: map[y * 16 - 1 + x],
        right: map[y * 16 + 1 + x],
        top: map[y * 16 - 16 + x],
        bottom: map[y * 16 + 16 + x],
      };
      if (x === 0) {
        if (block.bottom !== undefined) {
          if (block.current.tile[0] === '01r' && block.bottom.tile === '31') {
            block.current.tile = ['01brc', '31'];
          }
          if (block.current.tile[0] === '03r' && block.bottom.tile === '01') {
            block.current.tile = ['03brc', '01'];
          }
          if (block.current.tile === '31r' && block.bottom.tile === '62') {
            block.current.tile = '31brc';
          }
        }
        if (block.top !== undefined) {
          if (block.current.tile[0] === '01r' && block.top.tile === '31') {
            block.current.tile = ['01trc', '31'];
          }
          if (block.current.tile[0] === '03r' && block.top.tile === '01') {
            block.current.tile = ['03trc', '01'];
          }
          if (block.current.tile === '31r' && block.top.tile === '62') {
            block.current.tile = '31trc';
          }
        }
      }
      if (x === 15) {
        if (block.bottom !== undefined) {
          if (block.current.tile[0] === '01l' && block.bottom.tile === '31') {
            block.current.tile = ['01blc', '31'];
          }
          if (block.current.tile[0] === '03l' && block.bottom.tile === '01') {
            block.current.tile = ['03blc', '01'];
          }
          if (block.current.tile === '31l' && block.bottom.tile === '62') {
            block.current.tile = '31blc';
          }
        }
        if (block.top !== undefined) {
          if (block.current.tile[0] === '01l' && block.top.tile === '31') {
            block.current.tile = ['01tlc', '31'];
          }
          if (block.current.tile[0] === '03l' && block.top.tile === '01') {
            block.current.tile = ['03tlc', '01'];
          }
          if (block.current.tile === '31l' && block.top.tile === '62') {
            block.current.tile = '31tlc';
          }
        }
      }
      if (block.right !== undefined && block.top !== undefined) {
        if (
          block.current.tile === '31l' &&
          block.right.tile === '31r' &&
          block.top.tile === '62'
        ) {
          block.current.tile = '31tlc';
          block.right.tile = '31trc';
        }
      }
      if (block.right !== undefined && block.bottom !== undefined) {
        if (
          block.current.tile[0] === '01l' &&
          block.right.tile[0] === '01r' &&
          block.bottom.tile === '31'
        ) {
          block.current.tile = ['01blc', '31'];
          block.right.tile = ['01brc', '31'];
        }
        if (
          block.current.tile[0] === '03l' &&
          block.right.tile[0] === '03r' &&
          block.bottom.tile === '01'
        ) {
          block.current.tile = ['03blc', '01'];
          block.right.tile = ['03brc', '01'];
        }
      }
    }
  }
};

export { generateTerrain };
